var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasses = function SvgPasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.161 15.143c-.929-.07-1.63-.734-1.716-1.663a40 40 0 0 1-.135-2.16c-.015-.385.25-.715.583-.908a2.496 2.496 0 0 0 .915-3.41 2.5 2.5 0 0 0-.915-.912c-.333-.194-.598-.524-.583-.91.035-.916.084-1.623.134-2.16.086-.928.788-1.593 1.717-1.663 1.24-.092 3.38-.19 6.899-.19s5.66.097 6.898.19c.93.07 1.63.734 1.717 1.663.05.537.098 1.244.134 2.16.015.385-.25.715-.584.909a2.495 2.495 0 0 0 .001 4.322c.334.193.598.524.584.909a40 40 0 0 1-.135 2.16c-.086.929-.787 1.594-1.717 1.663-1.238.093-3.379.19-6.898.19-3.52 0-5.66-.097-6.899-.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.56 13.667v1.562M12.56 9.5v1.667M12.56 5.333V7M12.56 1.27v1.563"
  })));
};
export default SvgPasses;